export default __webpack_public_path__ + "static/media/fileImage.d071c081.svg";